// Category buckets for the landing page, plus the matching helpers.
//
// The rule for what counts as "Computational" lives here and nowhere else, so
// the pills, the tallies, and the list can never disagree about it.

export const FILTER_CATEGORIES = ["All", "Computational", "Product"];

/** A project belongs to a bucket via `category` or legacy `categories[]`. */
export function matchesFilter(project, filter) {
  if (!filter || filter === "All") return true;
  if (project.category === filter) return true;
  return Array.isArray(project.categories) && project.categories.includes(filter);
}

export function filterProjects(projects, filter) {
  return projects.filter((project) => matchesFilter(project, filter));
}

/** `{ All: 12, Computational: 8, Product: 4 }` — for the tallies on the pills. */
export function countsByFilter(projects, filters = FILTER_CATEGORIES) {
  return filters.reduce((counts, filter) => {
    counts[filter] = filterProjects(projects, filter).length;
    return counts;
  }, {});
}
